import { LanguageDto } from 'src/types/generated';
import BaseReadApiModule from 'src/api/baseRead';

class LanguageApi extends BaseReadApiModule<LanguageDto> {
  protected baseRoute = '/languages';
}

export default LanguageApi;
